import React from "react";
import styles from "./Nav.module.css";

const Nav = () => {
  return (
    <nav>
      <a href="#header">
        <span>HOME</span>
      </a>

      <a href="#about">
        <span>ABOUT</span>
      </a>

      <a href="#portofolio">
        <span>PORTFOLIO</span>
      </a>

      <a href="#contact">
        <span>CONTACT</span>
      </a>
    </nav>
  );
};

export default Nav;
